@if (value()) {
<button
  type="button"
  class="m-0 inline-flex max-w-72 min-w-0 cursor-pointer items-center gap-1 rounded-md px-1.5 py-0.5 font-mono text-xs text-secondary transition-[opacity,color,background-color] duration-150 hover:bg-zinc-400/15 hover:text-primary hover:opacity-90 md:max-w-96 dark:hover:bg-zinc-500/20"
  [class]="idButtonClass()"
  (click)="copyId()"
  [attr.aria-label]="copyAriaLabel()"
  [title]="copyTitle()">
  <span class="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">{{ value() }}</span>
  @if (copied()) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="size-3 shrink-0 text-green-500"
    aria-hidden="true">
    <path d="M20 6 9 17l-5-5" />
  </svg>
  } @else {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="size-3 shrink-0"
    aria-hidden="true">
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
  </svg>
  }
</button>
}
